function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSiteGradientTerrestrialSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 29.104166 29.104167",
    id: "svg19093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-267.89582)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#8abfec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.30182102,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-0-2",
    width: 29.104166,
    height: 29.104166,
    x: 0,
    y: 267.89581,
    rx: 14.552083,
    ry: 14.552083
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#0073cf",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.2743828,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-0-0",
    width: 26.458334,
    height: 26.458334,
    x: 1.3229166,
    y: 269.21875,
    rx: 13.229167,
    ry: 13.229167
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#8abfec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950617,
      strokeOpacity: 1
    },
    id: "rect4518-85-4-5",
    width: 21.166666,
    height: 21.166666,
    x: 3.96875,
    y: 271.86456,
    rx: 10.583333,
    ry: 10.583333
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#925214",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19206792,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-7-0-8",
    width: 18.520834,
    height: 18.520834,
    x: 5.2916665,
    y: 273.1875,
    rx: 9.260417,
    ry: 9.260417
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#8abfec",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.23597811,
      strokeOpacity: 1
    },
    d: "m 15.385656,278.58903 c -0.841123,0 -2.171989,2.26517 -2.173511,2.78239 -0.0015,0.51721 1.557047,1.67028 1.557047,2.0176 0,0.34731 -0.03874,0.65704 -0.474943,0.65704 -0.436195,0 -1.959014,-3.09711 -2.420007,-3.09709 -0.460993,1e-5 -3.6982813,3.45989 -3.2753803,4.19237 0.422901,0.73249 11.5916323,0.54493 11.9062493,0 0.314618,-0.54493 -4.278334,-6.55231 -5.119455,-6.55231 z",
    id: "rect4563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSiteGradientTerrestrialSelected);
export default __webpack_public_path__ + "static/media/icon-site-gradient-terrestrial-selected.eecb639639c6bc2b24b73eb1e56e32d4.svg";
export { ForwardRef as ReactComponent };